<div class="role-panel role-panel--warehouse info-card order-workspace">
  <h2 class="role-panel__title">{{
    (facade.warehousePanelMode() === 'handover'
      ? 'staff.orders.cockpit.warehouseHandoverPanelTitle'
      : 'staff.orders.cockpit.warehousePanelTitle'
    ) | translate
  }}</h2>
  @if (facade.warehousePanelMode() === 'receive') {
  <div class="order-workspace__section warehouse-receive">
    <div class="warehouse-receive__head">
      <span class="warehouse-receive__label">{{
        'admin.storageRequests.receiveWarehouseLabel' | translate
      }}</span>
      @if (facade.receiveWarehouseLoading()) {
      <span class="warehouse-receive__warehouse">{{
        'common.loading' | translate
      }}</span>
      } @else if (facade.receiveWarehouseInfo(); as wh) {
      <span class="warehouse-receive__warehouse">{{ wh.name }}</span>
      } @else {
      <span class="warehouse-receive__warehouse warehouse-receive__warehouse--muted">{{
        'admin.storageRequests.receiveWarehouseUnknown' | translate
      }}</span>
      }
    </div>
    @if (facade.receiveProgress(); as rp) {
    <p class="warehouse-receive__progress">
      {{
        'admin.storageRequests.receiveProgress'
          | translate: { received: rp.received, total: rp.total }
      }}
    </p>
    } @else if (facade.inventoryLoading()) {
    <p class="warehouse-receive__hint">{{
      'admin.storageRequests.receiveProgressLoading' | translate
    }}</p>
    }
    @if (facade.storage(); as inv) {
    <ul
      class="warehouse-receive__boxes"
      [attr.aria-label]="
        'admin.storageRequests.receiveBoxesListAria' | translate
      "
    >
      @for (b of inv.boxes; track b.box_id) {
      <li class="warehouse-receive__box-row">
        <span class="warehouse-receive__box-id mono">{{
          facade.shortBoxId(b.box_id)
        }}</span>
        <span
          class="warehouse-receive__box-status"
          [class.warehouse-receive__box-status--done]="
            b.status === 'stored'
          "
          >{{ facade.storageStatusLabel(b.status) }}</span
        >
      </li>
      }
    </ul>
    @if (inv.boxes.length === 0) {
    <p class="warehouse-receive__hint">{{
      'admin.storageRequests.receiveNoBoxesYet' | translate
    }}</p>
    }
    @if (inv.lines.length > 0 || inv.boxes.length > 0) {
    <div class="warehouse-receive__items">
      <p class="warehouse-receive__items-title">{{
        'admin.storageRequests.receiveItemsCardsTitle' | translate
      }}</p>
      <div class="warehouse-receive__items-grid">
        @for (line of inv.lines; track line.id) {
          @if (line.item_id && !facade.orderLineItemInBox(line)) {
          <div class="warehouse-receive__item-card-row">
            <button
              type="button"
              class="warehouse-receive__item-card"
              [disabled]="facade.saving()"
              (click)="facade.openOrderCompositionLine(line, 'warehouse_receive')"
            >
              <span class="warehouse-receive__item-name">{{
                facade.orderCompositionLineLabel(line)
              }}</span>
              <span class="warehouse-receive__item-meta">{{
                'admin.moverInventory.standaloneFlow' | translate
              }}</span>
            </button>
            <button
              type="button"
              class="warehouse-receive__item-print"
              [disabled]="facade.saving()"
              (click)="facade.printMoverQr(line.item_id!, 'item'); facade.receiveManualCode.set(line.item_id!)"
            >
              {{ 'admin.moverInventory.printQr' | translate }}
            </button>
          </div>
          }
        }
        @for (box of inv.boxes; track box.box_id) {
          @for (item of box.items; track item.id) {
          <div class="warehouse-receive__item-card-row">
            <button
              type="button"
              class="warehouse-receive__item-card"
              [disabled]="facade.saving()"
              (click)="facade.openOrderCompositionBoxItem(item, 'warehouse_receive')"
            >
              <span class="warehouse-receive__item-name">{{ facade.orderStorageItemLabel(item) }}</span>
              <span class="warehouse-receive__item-meta">{{
                'admin.storageRequests.orderItemsKindBox' | translate
              }} · {{ facade.shortBoxId(box.box_id) }}</span>
            </button>
            <button
              type="button"
              class="warehouse-receive__item-print"
              [disabled]="facade.saving()"
              (click)="facade.printMoverQr(item.id, 'item'); facade.receiveManualCode.set(item.id)"
            >
              {{ 'admin.moverInventory.printQr' | translate }}
            </button>
          </div>
          }
        }
      </div>
    </div>
    }
    }
    @if (facade.canWarehouseCreateQrBox()) {
    <div class="warehouse-receive__labeling">
      <p class="warehouse-receive__hint">{{
        'admin.storageRequests.receiveWithoutQrHint' | translate
      }}</p>
      <label class="warehouse-receive__field-label" for="warehouse-box-size">{{
        'admin.storageRequests.receiveBoxSizeLabel' | translate
      }}</label>
      <select
        id="warehouse-box-size"
        class="warehouse-receive__select"
        [ngModel]="facade.selectedBoxSizeId()"
        (ngModelChange)="facade.selectedBoxSizeId.set($event)"
        [disabled]="facade.saving() || facade.inventoryLoading()"
      >
        @for (size of facade.boxSizeOptions(); track size.id) {
        <option [value]="size.id">{{ size.name }}</option>
        }
      </select>
      <lib-cabinet-button
        class="processing-action warehouse-receive__create-qr"
        variant="secondary"
        secondaryTone="brand"
        size="lg"
        [fullWidth]="true"
        [text]="'admin.storageRequests.receiveCreateAndPrintQr' | translate"
        [action]="{ type: 'action' }"
        [disabled]="facade.saving() || facade.inventoryLoading()"
        [isLoading]="facade.savingMode() === 'box'"
        (actionEvent)="facade.createWarehouseBoxAndPrintQr()"
      />
      @if (facade.receiveManualCode().trim()) {
      <p class="warehouse-receive__hint">{{
        'admin.storageRequests.receiveLabelReadyHint' | translate
      }}</p>
      }
    </div>
    }
    <lib-cabinet-button
      class="processing-action warehouse-receive__scan"
      variant="primary"
      size="lg"
      [fullWidth]="true"
      [text]="'admin.storageRequests.scanToReceive' | translate"
      [action]="{ type: 'action' }"
      [disabled]="
          facade.saving() ||
          facade.inventoryLoading() ||
          facade.receiveBlockedByUnverifiedProfile()
        "
        [isLoading]="facade.savingMode() === 'receive'"
        (actionEvent)="facade.scanReceiveQr()"
    />
    <div class="warehouse-receive__manual">
      @if (facade.receiveBlockedByUnverifiedProfile()) {
      <p class="warehouse-receive__hint">{{
        'admin.users.items.receiveProfileNotVerifiedHint' | translate
      }}</p>
      }
      <p class="warehouse-receive__hint">{{
        'admin.storageRequests.receiveManualHint' | translate
      }}</p>
      <lib-not-input
        type="text"
        class="warehouse-receive__manual-input"
        [placeholder]="'admin.storageRequests.receiveManualPlaceholder' | translate"
        [ariaLabel]="'admin.storageRequests.receiveManualPlaceholder' | translate"
        [ngModel]="facade.receiveManualCode()"
        (ngModelChange)="facade.receiveManualCode.set($event)"
        [hideErrorBlock]="true"
        [disabled]="facade.saving() || facade.inventoryLoading()"
      />
      <lib-not-button
        class="warehouse-receive__manual-submit"
        [text]="'admin.storageRequests.receiveManualSubmit' | translate"
        [color]="'#140342'"
        [bgColor]="'#E8F9F7'"
        [width]="'100%'"
        [size]="'big'"
        [action]="{ type: 'action' }"
        [disabled]="
          facade.saving() ||
          facade.inventoryLoading() ||
          !facade.receiveManualCode().trim() ||
          facade.receiveBlockedByUnverifiedProfile()
        "
        [isLoading]="facade.savingMode() === 'receive'"
        (actionEvent)="facade.submitManualReceiveCode()"
      />
    </div>
  </div>
  } @else if (facade.warehousePanelMode() === 'handover') {
  <div class="order-workspace__section warehouse-receive warehouse-handover">
    <div class="warehouse-receive__head">
      <span class="warehouse-receive__label">{{
        'admin.storageRequests.handoverWarehouseLabel' | translate
      }}</span>
      @if (facade.receiveWarehouseLoading()) {
      <span class="warehouse-receive__warehouse">{{
        'common.loading' | translate
      }}</span>
      } @else if (facade.receiveWarehouseInfo(); as wh) {
      <span class="warehouse-receive__warehouse">{{ wh.name }}</span>
      } @else {
      <span class="warehouse-receive__warehouse warehouse-receive__warehouse--muted">{{
        'admin.storageRequests.receiveWarehouseUnknown' | translate
      }}</span>
      }
    </div>
    @if (facade.handoverProgress(); as hp) {
    <p class="warehouse-receive__progress">
      {{
        'admin.storageRequests.handoverProgress'
          | translate: { handedOver: hp.handedOver, total: hp.total }
      }}
    </p>
    } @else if (facade.inventoryLoading()) {
    <p class="warehouse-receive__hint">{{
      'admin.storageRequests.handoverProgressLoading' | translate
    }}</p>
    }
    @if (facade.storage(); as inv) {
    <ul
      class="warehouse-receive__boxes"
      [attr.aria-label]="
        'admin.storageRequests.handoverUnitsListAria' | translate
      "
    >
      @if (inv.lines.length > 0) {
        @for (line of inv.lines; track line.id) {
        <li class="warehouse-receive__box-row">
          <span class="warehouse-receive__box-id">{{
            facade.orderCompositionLineLabel(line)
          }}</span>
          <span class="warehouse-receive__box-status">{{
            facade.compositionLineStatusLabel(line)
          }}</span>
        </li>
        }
      } @else {
        @for (b of inv.boxes; track b.box_id) {
        <li class="warehouse-receive__box-row">
          <span class="warehouse-receive__box-id mono">{{
            facade.shortBoxId(b.box_id)
          }}</span>
          <span
            class="warehouse-receive__box-status"
            [class.warehouse-receive__box-status--done]="b.status === 'delivered'"
            >{{ facade.storageStatusLabel(b.status) }}</span
          >
        </li>
        }
      }
    </ul>
    @if (inv.lines.length === 0 && inv.boxes.length === 0) {
    <p class="warehouse-receive__hint">{{
      'admin.storageRequests.handoverNoUnitsYet' | translate
    }}</p>
    }
    }
    <lib-cabinet-button
      class="processing-action"
      variant="primary"
      size="lg"
      [fullWidth]="true"
      [text]="'admin.storageRequests.scanToHandover' | translate"
      [action]="{ type: 'action' }"
      [disabled]="facade.saving() || facade.inventoryLoading()"
      [isLoading]="facade.savingMode() === 'handover'"
      (actionEvent)="facade.scanHandoverQr()"
    />
    <div class="warehouse-receive__manual">
      <p class="warehouse-receive__hint">{{
        'admin.storageRequests.handoverManualHint' | translate
      }}</p>
      <lib-not-input
        type="text"
        class="warehouse-receive__manual-input"
        [placeholder]="'admin.storageRequests.handoverManualPlaceholder' | translate"
        [ariaLabel]="'admin.storageRequests.handoverManualPlaceholder' | translate"
        [ngModel]="facade.handoverManualCode()"
        (ngModelChange)="facade.handoverManualCode.set($event)"
        [hideErrorBlock]="true"
        [disabled]="facade.saving() || facade.inventoryLoading()"
      />
      <lib-not-button
        class="warehouse-receive__manual-submit"
        [text]="'admin.storageRequests.handoverManualSubmit' | translate"
        [color]="'#140342'"
        [bgColor]="'#E8F9F7'"
        [width]="'100%'"
        [size]="'big'"
        [action]="{ type: 'action' }"
        [disabled]="
          facade.saving() ||
          facade.inventoryLoading() ||
          !facade.handoverManualCode().trim()
        "
        [isLoading]="facade.savingMode() === 'handover'"
        (actionEvent)="facade.submitManualHandoverCode()"
      />
    </div>
  </div>
  }
</div>
